var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2.5 0 23 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.67,7.38h0a.5.5,0,0,0,.5-.5.5.5,0,0,0-.5-.5h0a.51.51,0,0,0-.5.5A.5.5,0,0,0,11.67,7.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,24.54H4.22a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5H13a.51.51,0,0,0,.5-.5A.5.5,0,0,0,13,24.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.08,8a.5.5,0,0,0-.5.5,3,3,0,1,1-3-3A3,3,0,0,1,10.26,6a.5.5,0,0,0,.56-.83,4,4,0,0,0-2.24-.68,4,4,0,1,0,4,4A.5.5,0,0,0,12.08,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58,0A8.59,8.59,0,0,0,1.66,13.66l6.51,9.66a.52.52,0,0,0,.41.22A.54.54,0,0,0,9,23.32l6.5-9.66a8.49,8.49,0,0,0,1.66-5.08A8.59,8.59,0,0,0,8.58,0Zm6.11,13.08,0,0-6.09,9-6.08-9,0,0A7.49,7.49,0,0,1,1,8.58a7.58,7.58,0,1,1,13.69,4.5Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLand);
export default __webpack_public_path__ + "static/media/land.e3d9944b.svg";
export { ForwardRef as ReactComponent };